module.exports = __webpack_public_path__ + "static/img/project-128x128.45e71510.jpg";